import { createFileRoute } from "@tanstack/react-router"
import DesignSystemSelect from "~/pages/design-system/components/Select"

export const Route = createFileRoute("/_auth/internal/design-system/components/select")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemSelect />
}
